import React, { useEffect, useState } from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { getFormDataApi } from 'api/client';
import { Divider } from '@material-ui/core';
import { system600, system900 } from 'Mui/styles/color';

const ENCRYPT_DATA_VALUE = '##encrypt';

export default function FormPanel(props) {
    const { formIds, entryUuid } = props;
    const [formAnswers, setFormAnswers] = useState([]);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const getFormData = async () => {
            try {
                if (!entryUuid) {
                    return;
                }
                setStatus('loading');
                const formDataPromises = Object.entries(formIds)
                    // eslint-disable-next-line no-unused-vars
                    .filter(([_, formId]) => formId)
                    // eslint-disable-next-line no-unused-vars
                    .map(([_, formId]) =>
                        getFormDataApi({
                            formId,
                            entryUuid
                        })
                    );

                if (formDataPromises.length > 0) {
                    const [signUpFormData, gameFormData] = await Promise.all(formDataPromises);
                    // 合併兩個 payload.items
                    const mergedItems = [
                        signUpFormData?.payload?.items || [],
                        gameFormData?.payload?.items || []
                    ];
                    setFormAnswers(mergedItems);
                }
                setStatus('success');
            } catch (err) {
                setStatus('fail');
                console.log(err);
            }
        };
        getFormData();
    }, [formIds, entryUuid]);

    function transFormReply(reply) {
        // if (reply.match(/\d+_[\d\w]+.[\d\w]+/g)) {
        //     return <AttachFileLink filename={reply} formId={signupFormId} />;
        // }
        if (reply === ENCRYPT_DATA_VALUE) {
            return i18n.t('form.report.label.encrypted_column');
        }
        return reply;
    }
    return (
        <div css={containerStyle}>
            {status === 'loading' && <Skeleton />}
            {status === 'fail' && i18n.t('desc.form.get_entry_form_answer_error')}
            {status === 'success' &&
                formAnswers.every(answers => answers.length === 0) &&
                'no data'}
            {status === 'success' &&
                formAnswers.map((answers, formIndex) => (
                    <div key={formIndex}>
                        {answers.length > 0 && (
                            <>
                                {formIndex > 0 && <Divider css={dividerStyle} />}
                                {answers.map(answer => (
                                    <QuestionAnswerPair
                                        key={answer.id}
                                        question={answer.fieldName}
                                        answer={transFormReply(answer.userInput)}
                                    />
                                ))}
                            </>
                        )}
                    </div>
                ))}
        </div>
    );
}

function QuestionAnswerPair({ question, answer }) {
    return (
        <div css={questionAnswerPairStyle}>
            <Typography variant="subtitle2" css={titleStyle}>
                {question}
            </Typography>
            <Typography variant="subtitle2" css={bodyStyle}>
                {answer.length === 0 ? i18n.t('label.no_reply') : answer}
            </Typography>
        </div>
    );
}

const containerStyle = css`
    display: flex;
    flex-direction: column;
`;

const titleStyle = css`
    color: ${system600.color};
    font-feature-settings: 'liga' off, 'clig' off;
`;

const bodyStyle = css`
    color: ${system900.color};
    font-feature-settings: 'liga' off, 'clig' off;
`;

const dividerStyle = css`
    margin: 8px 0;
    background: rgba(0, 0, 0, 0.2);
`;

const questionAnswerPairStyle = css`
    margin: 8px 0;
`;